import { IconProps } from "../../utils/global-types/global-types";

const CategoryIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-5 h-5"}
      {...rest}
    >
      <g clipPath="url(#clip0_10284_118573)">
        <path
          d="M5.84895 7.875H11.3989C11.9989 7.875 12.3739 7.2 11.9989 6.75L9.22395 2.175C8.92395 1.725 8.24895 1.725 7.94895 2.175L5.17395 6.75C4.87395 7.275 5.24895 7.875 5.84895 7.875Z"
          fill="currentColor"
        />
        <path
          d="M12.75 16.125C14.614 16.125 16.125 14.614 16.125 12.75C16.125 10.886 14.614 9.375 12.75 9.375C10.886 9.375 9.375 10.886 9.375 12.75C9.375 14.614 10.886 16.125 12.75 16.125Z"
          fill="currentColor"
        />
        <path
          d="M7.125 9.75H2.625C2.25 9.75 1.875 10.125 1.875 10.5V15C1.875 15.375 2.25 15.75 2.625 15.75H7.125C7.5 15.75 7.875 15.375 7.875 15V10.5C7.875 10.125 7.5 9.75 7.125 9.75Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_10284_118573">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CategoryIcon;
